import React from 'react'

function SideBar() {
    return (
        <div className="sidebar">
            
            

            <ul className="social-media-list">
                {/* <li>
                    <a href="">
                        <img src="https://unpkg.com/simple-icons@latest/icons/twitter.svg" alt="Twitter" title="Twitter"/>

                        </a>
                </li> */}
                <li className="sidebar-container"><a href="https://github.com/srizvyy" target="_blank" rel="noreferrer"><img src="https://unpkg.com/simple-icons@latest/icons/github.svg" alt="GitHub" title="GitHub"/></a><span id="github-text">Github</span></li>
                <li className="sidebar-container"><a href="https://www.linkedin.com/in/saimhrizvi/" target="_blank" rel="noreferrer"><img src="https://cdn-icons-png.flaticon.com/512/61/61109.png" alt="LinkedIn" title="LinkedIn"/></a><span id="linkedin-text">LinkedIn</span></li>
                {/* <li><a href="https://www.youtube.com/channel/UChV2-HyJ9XzsKLQRztd7Pmw"><img src="https://unpkg.com/simple-icons@latest/icons/youtube.svg" alt="YouTube" title="YouTube"/></a></li> */}
                <li className="sidebar-container"><a href="https://medium.com/@SaimRizvi" target="_blank" rel="noreferrer"><img src="https://www.pinclipart.com/picdir/middle/125-1254859_medium-icon-medium-icon-black-clipart.png" alt="Medium" title="Medium"/></a><span id="medium-text">Blog</span></li>
            </ul>



        </div>
    )
}

export default SideBar
